// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1i3Ud{width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100%}._1i3Ud ._3UJlR{padding:20px}._3luz_{display:flex;align-items:flex-end}._3luz_ ._1dkj-{max-width:100%;padding:0 12px}\n", ""]);
// Exports
exports.locals = {
	"root": "_1i3Ud",
	"wrappingContainer": "_3UJlR",
	"imageBox": "_3luz_",
	"image": "_1dkj-"
};
module.exports = exports;
